'use strict';

export default class AdminController {

  constructor(User, dialogs, Auth, Config, $uibModal, DTOptionsBuilder) {
    'ngInject';
    
    // Use the User $resource to fetch all users
    this.users = User.query();
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.roles = Config.getPlatformConfig().getUserRoles();
    this.Auth = Auth;
    this.User = User;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('pageLength', 50)
      .withBootstrap();
  }

  patchUserRoles(user) {
    this.Auth.patchUserRoles(user);
  }

  activateUser(user) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'activateDeactivateFormComponent',
      resolve: {
        config: function() {
          return {
            user: user
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      notify => {

        this.User.activate({
          id: user._id,
          notify: notify
        },{},  _ => {
          this.users = this.User.query();
        }, err => {console.log(err)});

      },
      _ => { /* cancel */
      }
    );
  }

  deactivateUser(user) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'activateDeactivateFormComponent',
      resolve: {
        config: function() {
          return {
            user: user
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      notify => {

        this.User.deactivate({
          id: user._id,
          notify: notify
        }, {}, _ => {
          this.users = this.User.query();
        }, err => {console.log(err)});

      },
      _ => { /* cancel */
      }
    );
  }

  delete(user) {

    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Delete user?", "Do you really, really, really want to delete this user?" + userStr);
    dlg.result.then(() => {
      /* Delete the user */
      user.$remove();
      this.users.splice(this.users.indexOf(user), 1);
    }, () => {
      // Cancel
    });

  }
}



// WEBPACK FOOTER //
// ./client/~ap/app/admin/user-list/admin.controller.js